import { IAppState } from '../../redux';
import { getProblemReasons } from './getProblemReasons';
import { IBillingProblemReasons } from '../../services/billingPayments';

export const getProblemReason = (state: IAppState, type: keyof IBillingProblemReasons) => {
  const problemReasons = getProblemReasons(state);

  return problemReasons[type];
};
